/**
 * Opening the drill an address names.
 *
 * A marked 复习 handwriting card links to `/cidian/<character>/#xiezi`, and a
 * browser leaves a `<details>` closed when the id is on the element itself. The
 * entry's contents list links `#xiezi` too, and following it changes the
 * fragment without loading the page. Both open the block, and both bring it
 * into view: the browser's own scroll to the fragment lands before the page's
 * figures have taken their height, and was measured leaving the reader at the
 * top of the entry.
 */

/**
 * Open the block the address names now, and the one it names whenever it
 * changes.
 * @param blocks - The drills on the page.
 * @param named - The address's fragment, `#` and all, as the page loaded.
 */
export function openWhenNamed(
  blocks: readonly HTMLDetailsElement[],
  named: string,
): void {
  openNamed(blocks, named);
  addEventListener("hashchange", () => {
    openNamed(
      blocks.filter((block) => block.isConnected),
      location.hash,
    );
  });
}

/**
 * Open the block an address names, and bring it into view.
 * @param blocks - The drills on the page.
 * @param named - The address's fragment, `#` and all.
 */
function openNamed(blocks: readonly HTMLDetailsElement[], named: string): void {
  for (const block of blocks) {
    if (block.id !== "" && named === `#${block.id}`) {
      block.open = true;
      block.scrollIntoView({ block: "start" });
    }
  }
}
